// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2aW-Y","Label":"BuildControl_Label__2JJr2","Less":"BuildControl_Less__12-qL","More":"BuildControl_More__1c0Ad"};